import React from 'react';
import TextField from '@material-ui/core/TextField';
import PhoneNumberInput from '../../components/PhoneNumberInput/index';

const ContactForm = ({ disabled, name, setName, phone, setPhone, email, setAttendeeEmail, isAttendee, isRequiredName, isFormSubmited, extension, setExtension,isSameEmail }) => {
    return (
        <div className='contacts-form'>
            <h4 className='page-subtitle'>Enter your Contact information</h4>
            <div className='contacts-form__items'>
                <div className='contacts-form__items__item'>
                    <TextField
                        label="Your Name*"
                        value={name===null?'':name}
                        onChange={(e) => setName(e.target.value)}
                        fullWidth
                        margin="normal"
                        variant="outlined"
                        disabled={disabled}
                        error={isRequiredName}
                        helperText={(isRequiredName ? "This field is required" : "")}
                    />
                </div>


                {isAttendee && (<div className='contacts-form__items__item'>
                    <TextField
                        margin="normal"
                        id="name"
                        label="Email Address*"
                        type="email"
                        fullWidth
                        variant="outlined"
                        onChange={(e) => { setAttendeeEmail(e.target.value); }}
                        value={email === null ? '':email}
                        error={isFormSubmited || isSameEmail}

                    />


                    {isFormSubmited && <span className="error-msg">Invalid Email Address</span>}
                    {isSameEmail && <span className="error-msg">Not allowed to enter same email as of host</span>}


                </div>)}



                <div className='contacts-form__items__item'>
                    {
                        <PhoneNumberInput
                            disabled={disabled}
                            value={phone}

                            onChange={(e) => setPhone(e.target.value)}
                        />
                    }

                    {
                        //<TextField
                        //    label="Enter your phone"
                        //    value={phone}
                        //    onChange={(e) => setPhone(e.target.value)}
                        //    fullWidth
                        //    margin="normal"
                        //    variant="outlined"
                        //    disabled={disabled}
                        ///>

                        <TextField
                            label="Extension"
                            value={extension === null ? '' : extension}
                            onChange={(e) => setExtension(e.target.value)}
                            fullWidth
                            margin="normal"
                            variant="outlined"
                            disabled={disabled}
                            inputProps={{ maxLength: 10 }}
                        />
                    }
                </div>


            </div>
        </div>
    );
}

export default ContactForm;